import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { TopStrip } from "@/components/landing/StickyBar";
import { Confirmation, NextSteps } from "@/components/landing/ThankYou";
import { SummitInvite } from "@/components/landing/SummitInvite";
import { Footer } from "@/components/landing/FinalCta";

export default function ThankYouPage() {
  const [params] = useSearchParams();
  const name = (params.get("name") || "").trim().slice(0, 40);

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    const prevTitle = document.title;
    document.title = "You're In! | The Wealth Code Masterclass";
    return () => { meta.remove(); document.title = prevTitle; };
  }, []);

  return (
    <div className="min-h-screen bg-[#F6F3FD]" data-testid="thank-you-page">
      <TopStrip />
      <section className="px-4 pt-12 pb-14 sm:pt-16 sm:pb-20">
        <Confirmation name={name} />
        <NextSteps />
      </section>
      <SummitInvite />
      <Footer className="pb-10" />
    </div>
  );
}
